module.exports = __webpack_public_path__ + "static/img/weeklyHot.59acc5ac.svg";